module.exports = __webpack_public_path__ + "static/img/mGcBanner@2x.2251409f.png";